/* eslint-disable max-len */
import { formatCents } from '../../utils/money';
import BasePriceHandler from '../above-the-fold/price-handlers/base';
import { PRODUCT_CARD_PRICE, SUBSCRIPTION_PRICE_LABEL } from '../../classnames/product-card';

export default class PriceHandler extends BasePriceHandler {
  handle = ({
    price, subscriptionPrice, servings, otpDiscount
  }, node) => {
    this.updateCardPrice(price, subscriptionPrice, otpDiscount, servings, node);
  };

  updateCardPrice = (price, subscriptionPrice, otpDiscount, servings, node) => {
    const priceElements = node.querySelectorAll(PRODUCT_CARD_PRICE);
    const oneTimePrice = parseFloat(price);
    const otpPrice = formatCents(oneTimePrice);

    let priceFormatted = otpPrice;

    const isSubscription = node.querySelector(PRODUCT_CARD_PRICE)?.dataset?.isSubscription === 'true';

    const subscriptionPriceFormatted = formatCents(subscriptionPrice);

    const currentPrice = isSubscription ? subscriptionPrice : otpPrice;
    const perServingPrice = currentPrice / servings;

    const priceElementClassList = node.querySelector(SUBSCRIPTION_PRICE_LABEL)?.classList;
    const className = Array.from(priceElementClassList || []).join(' ');

    // TODO - rewrite to liquid code + trigger (Hide/Show)
    if (isSubscription) {
      priceFormatted =
        `<div class="${className} subscription-price-label__container js-subscription-price-label ">
          <span class="subscription-price-label__otp-price">${otpPrice}</span>
          <span class="subscription-price-label__subscription-price">${subscriptionPriceFormatted}<span class="subscription-postfix">/mo</span></span>
        </div>`;
    }

    // TODO - rewrite price handlers. They looks bad. Use inheritance from base price handler
    this.updateCurrentPrice(currentPrice, otpDiscount, node);
    this.updatePerServingPrice(perServingPrice, otpDiscount, node);
    this.updateSubscriptionPrice(subscriptionPrice, oneTimePrice, node);
    [...priceElements].forEach((element) => element.innerHTML = priceFormatted);
  };
}
